import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const SectionList = styled.ul`
  margin-top: 24px;
  padding: 10px 40px 10px 0;
  border-right: 1px solid rgb(242, 245, 248);

  li {
    list-style: none;
  }
`;

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
`;

const ButtonText = styled.span`
  font-size: 13px;
  line-height: 24px;
  font-weight: 500;
  color: var(---cc_color_link_primary);
  margin: 0px 0px 0px 4px;
`;

const NewIcon = styled.i`
  margin: 0 0 0 0;
  font-size: 20px;
  color: var(---cc_color_link_primary);
`;

const SectionTitleName = styled.span`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SectionItem = styled.a`
  height: 36px;
  position: relative;

  display: flex;
  align-items: center;

  padding: 12px 8px;
  margin: 0;

  border: 1px solid white;
  border-radius: 4px;

  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  background-color: ${(props) =>
    props.isFocus ? 'rgba(9, 103, 210, 0.1);' : 'var(--cc_color_background_1)'};
  border-color: ${(props) =>
    props.isFocus
      ? 'rgba(9, 103, 210, 0.25);'
      : 'var(--cc_color_background_1)'};
  color: ${(props) =>
    props.isFocus
      ? 'var(--cc_color_link_primary)'
      : 'var(--cc_color_text_default)'};

  &:hover {
    background-color: ${(props) =>
      props.isFocus
        ? 'rgba(9, 103, 210, 0.1);'
        : 'var(--cc_color_background_2)'}

  transition: 0.2s ease-in-out;
`;

const SectionItemWrapper = styled.div``;

const SectionsList = ({
  currentSection,
  handleSectionSelect,
  selectedSection,
  sections,
  setCreatingSection,
  creatingSection,
}) => {
  const selectSection = (section) => {
    handleSectionSelect(section);
    setCreatingSection(false);
  };

  const selectNew = () => {
    setCreatingSection(true);
    handleSectionSelect({ name: 'New Section', id: 'jjjjjjj' });
  };

  const currentSectionText = (sectionId) => {
    return sectionId === currentSection.id ? ' (current)' : null;
  };

  const sectionItems = sections.map((section) => (
    <li key={section.id}>
      <SectionItemWrapper>
        <SectionItem
          isFocus={!creatingSection && selectedSection.id === section.id}
          onClick={() => selectSection(section)}
        >
          <SectionTitleName className="truncate">
            {section.name}
            {currentSectionText(section.id)}
          </SectionTitleName>
        </SectionItem>
      </SectionItemWrapper>
    </li>
  ));

  return (
    <SectionList>
      {sectionItems}
      <li>
        <SectionItem onClick={selectNew} isFocus={creatingSection}>
          <Wrapper>
            <NewIcon className="mdi mdi-plus-circle-outline" />
            <ButtonText className="truncate">New Section</ButtonText>
          </Wrapper>
        </SectionItem>
      </li>
    </SectionList>
  );
};

SectionsList.propTypes = {
  currentSection: PropTypes.object,
  handleSectionSelect: PropTypes.func,
  selectedSection: PropTypes.object,
  sections: PropTypes.array,
  setCreatingSection: PropTypes.func,
  creatingSection: PropTypes.bool,
};

export default SectionsList;
